import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import DeliveryStatusService from "../../src/Services/DeliveryStatus.service";
const DeliveryStatusLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        labelKey: "status",
        fetchItemsById: (ids) => {
            return DeliveryStatusService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return DeliveryStatusService.searchAll(search);
        },
        optionRenderer: function optionRenderer(deliveryStatus) {
            return _jsx("span", { children: deliveryStatus.status });
        },
    });
};
export default DeliveryStatusLookup;
